import request from '@/utils/zsm-requets'
const file='/zsm/api/file/'
/**
 * 新增媒体
 *
 * bizId 	  类型id 如版权传课程id
 * bizClassFirst 	  素材默认是100
 * bizClassSec
  cover 封面
  title 标题
  cloudDict 默认'aliyun'
  url 媒体地址
  frontId
  bizId
 */
export function createFile(info) {
  return request({
    url: file+'create',
    method: 'post',
    params: info
  })
}


/* 删除素材  */
export function deleteFile(id) {
  return request({
    url: file+'delete',
    method: 'post',
    params: {id}
  })
}

/* 查看单个素材  */
export function getFile(params) {
  return request({
    url: file+'get',
    method: 'post',
    params
  })
}


/* 查看素材列表  */
export function listDataFile(params) {
  return request({
    url: file+'listData',
    method: 'post',
    params
  })
}

/* 修改素材  */
export function updateFile(params) {
  return request({
    url: file+'update',
    method: 'post',
    params
  })
}

// 素材替换
export function deleteAndCreate(params) {
  return request({
    url: file+'deleteAndCreate',
    method: 'post',
    params
  })
}
